import { page } from '$app/state';
import { WidgetAuthMode } from '#lib/types/generated/index.js';
import { apiWidgetAuthJwsLogout, apiWidgetMemberMe } from '#lib/types/generated/api.gen.js';
import type { WidgetMember } from '#lib/types/generated/widgetMember.gen.js';
import { get, writable } from 'svelte/store';
import { widgetConfig } from '#lib/widget/core.js';

export const widgetAuthenticatedMember = writable<WidgetMember | null>(null);

export function hasMemberAreaContent(
	authMode: WidgetAuthMode,
	member: WidgetMember | null
): boolean {
	return (
		authMode !== WidgetAuthMode.None &&
		member !== null &&
		(member.bookings.length > 0 || member.customerPackages.length > 0)
	);
}

export function loadMember(force: boolean = false): Promise<void> {
	if (
		!force &&
		(get(widgetConfig).memberArea.authMode === WidgetAuthMode.None ||
			get(widgetAuthenticatedMember))
	) {
		return Promise.resolve();
	}
	return apiWidgetMemberMe(page.params.hash!)
		.then((res) => {
			widgetAuthenticatedMember.set(res);
		})
		.catch((error) => {
			if (error?.response?.status === 401) {
				widgetAuthenticatedMember.set(null);
			} else {
				throw error;
			}
		});
}

export function refreshMember(): Promise<void> {
	if (!get(widgetAuthenticatedMember)) {
		return Promise.resolve();
	}
	return loadMember(true);
}

export function logoutMember(): Promise<void> {
	return apiWidgetAuthJwsLogout(page.params.hash!).then(() => {
		widgetAuthenticatedMember.set(null);
	});
}
